export default __webpack_public_path__ + "static/media/AppDrawerLogo.081d1041.svg";